// CANONICAL COPY (GH #7115). src/constants/obligations/obl-vendor-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-vendor-policy',
  title: 'Verify supplier information security policy',
  description:
    'Confirm that a supplier management policy exists, is published, and defines requirements for managing supplier information security risks, including ICT supply chain security considerations.',
  category: 'vendors',
  scfIds: ['SCF-VDR-001', 'SCF-VDR-003', 'SCF-VDR-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Supplier management policy is published' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
